import { Injectable, signal } from "@angular/core";

/** localStorage key remembering whether the viewer turned the cursor sparkles on. */
const ENABLED_STORAGE_KEY = "cursorSparkles:enabled";

/** December's sparkle trail behind the mouse cursor: off until the viewer turns it on. */
@Injectable({ providedIn: "root" })
export class CursorSparklesService {
	private readonly _enabled = signal<boolean>(readEnabled());
	readonly enabled = this._enabled.asReadonly();

	toggle(): void {
		const enabled = !this._enabled();
		this._enabled.set(enabled);
		try {
			localStorage.setItem(ENABLED_STORAGE_KEY, String(enabled));
		} catch {
			// Storage can be unavailable (private mode); the choice then lasts for this page only.
		}
	}
}

function readEnabled(): boolean {
	try {
		return localStorage.getItem(ENABLED_STORAGE_KEY) === "true";
	} catch {
		return false;
	}
}
